// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__8IcyH","label":"PriceFilterPopup_label__3Dgz8","labelSelected":"PriceFilterPopup_labelSelected__2TG6C"};